import React, { useEffect, useState } from "react";
import { Box, Typography, Card, Container, Divider } from "@mui/material";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import Logo from "../../assets/back2.png";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const UPLOAD_MYVIDEO__URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;
const VIDEO_BASE_URL = import.meta.env.VITE_VIDEO_BASE_URL;

import { useTranslation } from "react-i18next";
import axios from "axios";
import PdfViewerModal from "../../users/pdf_view/pdfviewermodal";
import Pdficon from "../../assets/pdf1.png";


type AnimationMedia = {
  videoUrl: string;
  homepageImageUrl?: string;
  bannerUrl: string;
  ImageUrl?: string;
};

// type MyVideoMedia = {
//   videoUrl: string;
//   ImageUrl: string;
// };

type AnimationDetails = {
  animationId: number;
  randomId: string;
  animationTagName: string;
  animationPdfStatus: boolean;
  animationDescription: {
    introductionTagName: string;
    conditionTagName: string;
    symptomsTagName: string;
    actionTagName: string;
  };
  animation_media: AnimationMedia;
};
type MyvideosDetails = {
  animationId: number;
  randomId: string;
  batchRandomNumber: string;
  linkExpireDate: string;
  animationTitle: string;
  animationType: string;
  animation_media: AnimationMedia;
};
type AnimationData = {
  businessDetails: {
    businessName: string | null;
    businessEntityLocationName: string;
    address: string;
    phone: string | null;
  };
  animationDetails: AnimationDetails[];
  myvideosDetails: MyvideosDetails[];
};
type AnimationDescription = {
  introductionTagName: string;
  conditionTagName: string;
  symptomsTagName: string;
  actionTagName: string;
};

type MyVideoDescription = {
  introductionTagName: string;
  conditionTagName: string;
  symptomsTagName: string;
  actionTagName: string;
};

type BusinessDetails = {
  businessName: string;
  businessEntityLocationName: string;
  address: string;
  phone: string;
};

const ShortURLAnimationViewnew: React.FC = () => {
  const [selectedVideo, setSelectedVideo] =
    useState < AnimationMedia | null > (null);
  const [isAnimContent, setIsAnimContent] = useState<AnimationData | null>(
    null
  );
  const [isBusinessDetails, setIsBusinessDetails] =
    useState<BusinessDetails | null>(null);
  const [isAnimDescription, setIsAnimDescription] = useState<
    AnimationDescription | MyVideoDescription | null
  >(null);
  const [isAnimTitle, setIsAnimTitle] = useState<string>("");
  const { t } = useTranslation();
  const shortCode = window.location.href.split("/").pop();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [animationID, setAnimationId] = useState<number | undefined>();
  const [isVideoBaseUrl, setIsVideoBaseUrl] = useState<string>("");
  const [myVideoType, setMyVideoType] = useState<string | undefined>("");
  const [selectedRandomId, setSelectedRandomId] = useState<string | null | undefined>(null);

  // Initially get System numbers

  useEffect(() => {
    setSelectedRandomId(shortCode); //  track which animation is selected
    const payload = { randomId: shortCode };

    axios
      .post(API_BASE_URL + "animation/getshortUrl", payload, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        const allData = response.data;

        if (allData.statusCode >= 200 && allData.statusCode <= 300) {
          const { data } = allData;
          // if (data) {
          //   setIsAnimContent(data);
          //   setIsBusinessDetails(data.businessDetails);

          //   // Find animation details by randomId
          //   const isRandomIdFound = data.animationDetails.find(
          //     (detail: any) => detail.randomId === shortCode
          //   );

          //   if (isRandomIdFound) {
          //     setIsAnimDescription(isRandomIdFound.animationDescription);
          //     setSelectedVideo(isRandomIdFound.animation_media);
          //     setIsAnimTitle(isRandomIdFound.animationTagName);

          //   } else {
          //   }
          // }
          if (data) {
            setIsAnimContent(data);
            setIsBusinessDetails(data.businessDetails);

            // Find in animationDetails first
            const foundInAnimation = data.animationDetails?.find(
              (detail: any) => detail.randomId === shortCode
            );

            // If not found, try in myVideosDetails
            const foundInMyVideos = data.myvideosDetails?.find(
              (detail: any) => detail.randomId === shortCode
            );

            const isRandomIdFound = foundInAnimation || foundInMyVideos;

            if (isRandomIdFound) {
              // Set common video media (from either source)
              setSelectedVideo(
                foundInAnimation?.animation_media || foundInMyVideos || null
              );

              // Only set description/title if from animation
              if (foundInAnimation) {
                setIsVideoBaseUrl(VIDEO_BASE_URL);
                setIsAnimDescription(
                  foundInAnimation.animationDescription || null
                );
                setSelectedVideo(foundInAnimation?.animation_media);
                setIsAnimTitle(foundInAnimation.animationTagName || "");
                setMyVideoType("");
              } else {
                setIsVideoBaseUrl(UPLOAD_MYVIDEO__URL);
                setSelectedVideo(foundInMyVideos?.animation_media);

                setIsAnimDescription(null);
                setIsAnimTitle(foundInMyVideos?.animationTitle || "");
                setMyVideoType(foundInMyVideos?.animationType);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [shortCode]);

  const handleOpenModal = (animationID: number) => {

    setIsModalOpen(true);
    setAnimationId(animationID);
  };

  // Close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAnimationVideo = (getRandomId: string) => {
    setSelectedRandomId(getRandomId); //  track which animation is selected

    // Try finding in animationDetails first
    const foundInAnimation = isAnimContent?.animationDetails.find(
      (detail: { randomId: string }) => detail.randomId === getRandomId
    );

    // If not found, try myVideosDetails
    const foundInMyVideos = isAnimContent?.myvideosDetails.find(
      (detail: { randomId: string }) => detail.randomId === getRandomId
    );

    const isRandomIdFound = foundInAnimation || foundInMyVideos;

    setSelectedVideo(isRandomIdFound?.animation_media || null);
    // Only set description and title if it was found in animationDetails
    if (foundInAnimation) {
      setIsVideoBaseUrl(VIDEO_BASE_URL);
      setMyVideoType("");
      setIsAnimDescription(foundInAnimation.animationDescription || null);
      setIsAnimTitle(foundInAnimation.animationTagName || "");
    } else {
      setIsVideoBaseUrl(UPLOAD_MYVIDEO__URL);
      setMyVideoType(foundInMyVideos?.animationType);
      setIsAnimDescription(null);
      setIsAnimTitle(foundInMyVideos?.animationTitle || "");
    }
    // setIsAnimDescription(isRandomIdFound?.animationDescription || null);
    // setIsAnimTitle(isRandomIdFound?.animationTagName || "");
    // Extract the current URL
    const currentUrl = new URL(window.location.href);
    // Update the path with the new randomId
    currentUrl.pathname = `/${getRandomId}`;
    // Update the URL without refreshing the page
    window.history.pushState({}, "", currentUrl.toString());
  };


  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Background Logo */}
      <Box
        aria-label="Logo Background"
        sx={{
          opacity: 0.2,
          position: "absolute",
          background: `url(${Logo}) repeat`,
          width: "100%",
          height: "100%",
        }}
      />

      {/* <Container sx={{ zIndex: 1 , mt:10}}> */}
      <Container
        sx={{
          zIndex: 1,
          mt: { xs: 2, sm: 4, md: 5, lg: 10 },
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box display="flex" flexDirection={{ xs: "column", lg: "row" }} p={2}>
          {/* Left Sidebar */}
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", lg: "30%" },
              maxWidth: { xs: "100%", sm: "100%", lg: "300px" },
              bgcolor: "#808080",
              mt: { xs: 50, sm: 70, lg: 1 },
              p: { xs: 1, md: 2, sm: 2 },
              display: "flex",
              flexDirection: "column",
              height: "auto",
              maxHeight: "80vh",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#fff",
                fontSize: { xs: "16px", md: "18px" },
              }}
            >
              Recommended Videos
            </Typography>
            <Divider sx={{ mb: 2, borderColor: "#fff" }} />
            <Box
              sx={{
                maxHeight: "calc(100vh - 180px)",
                maxWidth: { xs: "100%", lg: "300px" },
                overflowY: "auto",
                overflowX: "hidden",
                borderRadius: "8px",
                padding: "0px",
                paddingRight: "4px",
                margin: "1px",
              }}
            >
              {isAnimContent?.animationDetails.map((animation) => (
                <Box
                  key={animation.animationId}
                  sx={{
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                      selectedRandomId === animation.randomId
                        ? "#1976d2"
                        : "white",
                    color:
                      selectedRandomId === animation.randomId
                        ? "white"
                        : "black",
                    cursor: "pointer",
                    borderRadius: "4px",
                    flexDirection: "row",
                    width: "100%",
                    transition: "background-color 0.2s ease",
                  }}
                  onClick={() => handleAnimationVideo(animation.randomId)}
                >
                  <Box
                    sx={{
                      width: { xs: "80px", lg: "85px" },
                      height: { xs: "80px", lg: "85px" },
                      display: "flex",
                      justifyContent: "center",
                      padding: "4px",
                    }}
                  >
                    <img
                      src={animation.animation_media.homepageImageUrl}
                      alt={animation.animationTagName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                        padding: 1,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      pl: 2,
                      fontWeight: "bold",
                      whiteSpace: "normal",
                      flex: 1,
                      overflow: "hidden",
                      wordWrap: "break-word",
                      textAlign: "left",
                      fontSize: { xs: "12px", md: "16px" },
                    }}
                  >
                    {/* {t(animation.title)} */}
                    {t(animation.animationTagName)}
                  </Typography>
                  {animation.animationPdfStatus === true && (
                    <Box
                      sx={{
                        width: { xs: "80px", lg: "50px" },
                        height: { xs: "80px", lg: "50px" },
                        display: "flex",
                        justifyContent: "center",
                        padding: "6px",
                      }}
                    >
                      <img
                        src={Pdficon || "/placeholder.svg"}
                        alt="pdficon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                          padding: 4,
                          cursor: "pointer",
                        }}
                        onClick={() => handleOpenModal(animation.animationId)}
                      />
                    </Box>
                  )}

                  {isModalOpen && (
                    <Box sx={{ marginTop: 2 }}>
                      <PdfViewerModal
                        animationId={animationID}
                        onClose={handleCloseModal}
                      />
                    </Box>
                  )}
                </Box>
              ))}
              {isAnimContent?.myvideosDetails.map((animation) => (
                <Box
                  key={animation.animationId}
                  sx={{
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                      selectedRandomId === animation.randomId
                        ? "#1976d2"
                        : "white",
                    color:
                      selectedRandomId === animation.randomId
                        ? "white"
                        : "black",
                    cursor: "pointer",
                    borderRadius: "4px",
                    flexDirection: "row",
                    width: "100%",
                    transition: "background-color 0.2s ease",
                  }}
                  onClick={() => handleAnimationVideo(animation.randomId)}
                >
                  <Box
                    sx={{
                      width: { xs: "80px", lg: "85px" },
                      height: { xs: "80px", lg: "85px" },
                      display: "flex",
                      justifyContent: "center",
                      padding: "4px",
                    }}
                  >
                    <img
                      src={
                        animation.animationType != "3"
                          ? UPLOAD_MYVIDEO__URL +
                            animation.animation_media.ImageUrl
                          : animation.animation_media.ImageUrl
                      }
                      alt={animation.animationTitle}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                        padding: 1,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      pl: 2,
                      fontWeight: "bold",
                      whiteSpace: "normal",
                      flex: 1,
                      overflow: "hidden",
                      wordWrap: "break-word",
                      textAlign: "left",
                      fontSize: { xs: "12px", md: "16px" },
                    }}
                  >
                    {/* {t(animation.title)} */}
                    {t(animation.animationTitle)}
                  </Typography>
                  {/* {animation.animationPdfStatus === true && (
                    <Box
                      sx={{
                        width: { xs: "80px", lg: "50px" },
                        height: { xs: "80px", lg: "50px" },
                        display: "flex",
                        justifyContent: "center",
                        padding: "6px",
                      }}
                    >
                      <img
                        src={Pdficon || "/placeholder.svg"}
                        alt="pdficon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                          padding: 4,
                          cursor: "pointer",
                        }}
                        onClick={() => handleOpenModal(animation.animationId)}
                      />
                    </Box>
                  )} */}

                  {/* {isModalOpen && (
                    <Box sx={{ marginTop: 2 }}>
                      <PdfViewerModal
                        animationId={animationID}
                        onClose={handleCloseModal}
                      />
                    </Box>
                  )} */}
                </Box>
              ))}
            </Box>
          </Box>

          {/* Main Content */}
          <Box
            sx={{
              flex: 1,
              ml: { xs: 0, lg: 3 },
              mt: { xs: 2, lg: 0 },
              backgroundColor: "#f5f5f5",
              boxShadow: "2px 1px 11px rgb(0 0 0 / 29%)",
            }}
          >
            {/* Video Section */}
            <Typography
              variant="h6"
              sx={{
                padding: 2,
                fontWeight: "bold",
                marginBottom: "-5px",
                backgroundColor: "#1976d2",
                color: "white",
                textAlign: "center",
                fontSize: { xs: "16px", md: "18px" },
              }}
            >
              {t(isAnimTitle)}
            </Typography>
            <Card sx={{ borderRadius: "0px", backgroundColor: "transparent" }}>
              {selectedVideo ? (
                <MediaPlayer
                  className="carouselvideo"
                  key={selectedVideo.videoUrl} //initially plays the 1st video to run
                  src={
                    myVideoType === "3"
                      ? selectedVideo.videoUrl
                      : isVideoBaseUrl + selectedVideo.videoUrl
                  }
                  viewType="video"
                  streamType="on-demand"
                  logLevel="warn"
                  crossOrigin
                  playsInline
                  autoPlay
                >
                  <MediaProvider></MediaProvider>
                  <DefaultVideoLayout icons={defaultLayoutIcons} />
                </MediaPlayer>
              ) : (
                <Typography
                  sx={{
                    padding: 4,
                    textAlign: "center",
                    color: "gray",
                  }}
                >
                  Please select a video from the left to play.
                </Typography>
              )}
            </Card>
            {myVideoType === "" && (
              <>
                {/* Tab Content */}
                <Box
                  sx={{
                    maxHeight: "200px",
                    overflow: "auto",
                    p: 2,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  {/* {myVideoType === "" && ( */}
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Descriptions
                  </Typography>
                  {/* )} */}

                  <Typography variant="body1" sx={{ fontSize: "18px" }}>
                    <h5 style={{ fontWeight: "500" }}>
                      {isAnimDescription?.introductionTagName}
                    </h5>
                    <h5 style={{ fontWeight: "500" }}>
                      {isAnimDescription?.conditionTagName}
                    </h5>
                    <h5 style={{ fontWeight: "500" }}>
                      {isAnimDescription?.symptomsTagName}
                    </h5>
                    <h5 style={{ fontWeight: "500" }}>
                      {isAnimDescription?.actionTagName}
                    </h5>
                  </Typography>
                </Box>
              </>
            )}

            {/* Footer */}
            <Box
              mt={0}
              p={1}
              bgcolor="grey.200"
              borderRadius={1}
              textAlign="center"
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {isBusinessDetails?.businessEntityLocationName}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ fontSize: { xs: "12px", md: "14px" } }}
              >
                {isBusinessDetails?.address}
              </Typography>
              <Typography sx={{ fontSize: { xs: "12px", md: "14px" } }}>
                {/* 9503503906 */}
                {isBusinessDetails?.phone}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ShortURLAnimationViewnew;
